// extracted by mini-css-extract-plugin
export default {"container":"CmsSiteEndComponent-module__container-ZkAfb_","main":"CmsSiteEndComponent-module__main-iDdKEs"};